/** Damage red: reads as a hit on every player colour except the red ones. */
export const DAMAGE_FLASH_RED = '#E5262D'
/** On a red territory a red wash barely shows, so the flash goes pale and hot instead. */
export const DAMAGE_FLASH_HOT = '#FFC2B8'

function hueSat(hex: string): { hue: number; sat: number } | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return null
  const n = parseInt(m[1]!, 16)
  const r = ((n >> 16) & 255) / 255
  const g = ((n >> 8) & 255) / 255
  const b = (n & 255) / 255
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const d = max - min
  if (d === 0) return { hue: 0, sat: 0 }
  const sat = d / (1 - Math.abs(max + min - 1))
  const raw = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4
  return { hue: (raw * 60 + 360) % 360, sat }
}

/** The flash colour for a territory owned by `ownerHex` (the owner's player colour). */
export function damageFlashColor(ownerHex: string | undefined): string {
  const hs = ownerHex ? hueSat(ownerHex) : null
  if (!hs || hs.sat < 0.35) return DAMAGE_FLASH_RED
  const fromRed = Math.min(hs.hue, 360 - hs.hue)
  return fromRed <= 22 ? DAMAGE_FLASH_HOT : DAMAGE_FLASH_RED
}
